<template>
  <div>
    <c-tab
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :dense="true"
      :height="tabHeight"
      :tabOptions.sync="tabOptions"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param.sync="popupParam"
          :psmFlag.sync="psmFlag"
          :ghsFlag.sync="ghsFlag"
          @insertEquipInfo="updateMode"
          @updateChemInfo="updateData"
        />
      </template>
    </c-tab>
  </div>
</template>
<script>
import { uid } from 'quasar';
export default {
  name: 'chem-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        tabName: '',
        updateFlag: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'chemInfo',
      tabItems: [
        { name: 'chemInfo', icon: 'info', label: '화학자재 기본정보', class:'tab-orange', component: () => import(`${'./chemInfo.vue'}`) },
      ],
      addTabItems: [
        { name: 'chemEtc', icon: 'details', label: '화학자재 상세정보', component: () => import(`${'./chemEtc.vue'}`) },
        { name: 'chemMsds', icon: 'content_paste', label: '구성물질 정보/규제', component: () => import(`${'./chemComponents.vue'}`) },
        { name: 'chemGhs', icon: 'gavel', label: '제품별 GHS정보', component: () => import(`${'./chemGhs.vue'}`) },
        { name: 'chemPsm', icon: 'warning_amber', label: '유해위험방지계획서', component: () => import(`${'./chemPsm.vue'}`) },
      ],
      psmFlag: {
        bool: false,
        watch: '',
      },
      ghsFlag: {
        bool: false,
        watch: '',
      },
      tabOptions: {
        chemPsm: {
          tabLabelStyle: ''
        },
        chemGhs: {
          tabLabelStyle: ''
        },
      }
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  watch: {
    'psmFlag.watch'() {
      this.$set(this.tabOptions['chemPsm'], 'tabLabelStyle', !this.psmFlag.bool ? 'text-decoration-line:line-through;text-decoration-color:#C10015' : '')
      this.$set(this.tabItems[this.$_.findIndex(this.tabItems, { name: 'chemPsm' })], 'disabled', !this.psmFlag.bool ? true : false)
    },
    'ghsFlag.watch'() {
      this.$set(this.tabOptions['chemGhs'], 'tabLabelStyle', !this.ghsFlag.bool ? 'text-decoration-line:line-through;text-decoration-color:#C10015' : '')
      this.$set(this.tabItems[this.$_.findIndex(this.tabItems, { name: 'chemGhs' })], 'disabled', !this.ghsFlag.bool ? true : false)
    },
  },
  methods: {
    init() {
      if (this.popupParam.tabName) {
        this.tab = this.popupParam.tabName;
      }
      if (this.popupParam.mdmChemMaterialId != '') {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    updateMode(_mdmChemMaterialId) {
      this.popupParam.mdmChemMaterialId = _mdmChemMaterialId;
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
    updateData() {
      this.$set(this.popupParam, 'updateFlag', uid())
    }
  }
};
</script>